export default "__VITE_ASSET__BQVWIarl__"